import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { contabilidadService } from '../services/api';
import '../styles/Dashboard.css';

const Contabilidad = () => {
  const [loading, setLoading] = useState(false);
  const [resumen, setResumen] = useState({
    balance_general: 0,
    ingresos_mes: 0,
    egresos_mes: 0,
    utilidad_mes: 0
  });

  useEffect(() => {
    cargarResumen();
  }, []);

  const cargarResumen = async () => {
    setLoading(true);
    try {
      const response = await contabilidadService.getResumen();
      setResumen(response.data);
    } catch (error) {
      console.error('Error al cargar resumen:', error);
      // Mantener datos por defecto en caso de error
    } finally {
      setLoading(false);
    }
  };

  const formatMoney = (amount) => {
    return `$${(amount || 0).toLocaleString('es-DO', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`;
  };

  return (
    <div className="dashboard-page">
      <div className="dashboard-header">
        <h1>🧮 Contabilidad</h1>
        <p className="subtitle">Gestión contable y financiera del sistema</p>
      </div>

      {/* Resumen Financiero */}
      <div className="stats-grid">
        <div className="stat-card blue">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <h3>Balance General</h3>
            <p className="stat-value">{formatMoney(resumen.balance_general)}</p>
            <p className="stat-label">Total en cuentas</p>
          </div>
        </div>

        <div className="stat-card green">
          <div className="stat-icon">📈</div>
          <div className="stat-content">
            <h3>Ingresos del Mes</h3>
            <p className="stat-value">{formatMoney(resumen.ingresos_mes)}</p>
            <p className="stat-label">Total ingresos</p>
          </div>
        </div>

        <div className="stat-card orange">
          <div className="stat-icon">📉</div>
          <div className="stat-content">
            <h3>Egresos del Mes</h3>
            <p className="stat-value">{formatMoney(resumen.egresos_mes)}</p>
            <p className="stat-label">Total egresos</p>
          </div>
        </div>

        <div className="stat-card purple">
          <div className="stat-icon">💵</div>
          <div className="stat-content">
            <h3>Utilidad del Mes</h3>
            <p className="stat-value">{formatMoney(resumen.utilidad_mes)}</p>
            <p className="stat-label">Ganancia neta</p>
          </div>
        </div>
      </div>

      {/* Módulos Principales */}
      <div className="dashboard-grid">
        <div className="dashboard-card dashboard-card-clickable">
          <Link to="/contabilidad/cuadre-pagos" className="card-link">
            <div className="card-header card-header-blue">
              <h2>💰 Cuadre Pagos</h2>
            </div>
            <div className="card-content">
              <p className="card-description">
                Cuadre de pagos por cobrador y período
              </p>
              <button className="btn btn-primary card-btn">
                Abrir Módulo
              </button>
            </div>
          </Link>
        </div>

        <div className="dashboard-card dashboard-card-clickable">
          <Link to="/contabilidad/cuadre-rutas" className="card-link">
            <div className="card-header card-header-green">
              <h2>🗺️ Cuadre Rutas</h2>
            </div>
            <div className="card-content">
              <p className="card-description">
                Cuadre de pagos por rutas de cobro
              </p>
              <button className="btn btn-success card-btn">
                Abrir Módulo
              </button>
            </div>
          </Link>
        </div>

        <div className="dashboard-card dashboard-card-clickable">
          <Link to="/contabilidad/calculadora-cuota" className="card-link">
            <div className="card-header card-header-orange">
              <h2>🧮 Calculadora Cuota</h2>
            </div>
            <div className="card-content">
              <p className="card-description">
                Calcule cuotas y tabla de amortización
              </p>
              <button className="btn btn-warning card-btn">
                Abrir Módulo
              </button>
            </div>
          </Link>
        </div>
      </div>

      <h2 style={{marginTop: '2rem', marginBottom: '1rem'}}>Otros Módulos</h2>

      {/* Módulos de Contabilidad */}
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <div className="card-header">
            <h2>📊 Libro Mayor</h2>
          </div>
          <div className="card-content">
            <p style={{color: '#666', textAlign: 'center', padding: '2rem'}}>
              Registro de todas las transacciones contables
            </p>
            <button className="btn btn-primary" style={{width: '100%'}} disabled>
              Ver Libro Mayor
            </button>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h2>📝 Diario General</h2>
          </div>
          <div className="card-content">
            <p style={{color: '#666', textAlign: 'center', padding: '2rem'}}>
              Asientos contables diarios
            </p>
            <button className="btn btn-primary" style={{width: '100%'}} disabled>
              Ver Diario
            </button>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h2>💼 Balance General</h2>
          </div>
          <div className="card-content">
            <p style={{color: '#666', textAlign: 'center', padding: '2rem'}}>
              Estado de situación financiera
            </p>
            <button className="btn btn-primary" style={{width: '100%'}} disabled>
              Ver Balance
            </button>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h2>📈 Estado de Resultados</h2>
          </div>
          <div className="card-content">
            <p style={{color: '#666', textAlign: 'center', padding: '2rem'}}>
              Ganancias y pérdidas del período
            </p>
            <button className="btn btn-primary" style={{width: '100%'}} disabled>
              Ver Estado
            </button>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h2>🏦 Conciliación Bancaria</h2>
          </div>
          <div className="card-content">
            <p style={{color: '#666', textAlign: 'center', padding: '2rem'}}>
              Conciliación de cuentas bancarias
            </p>
            <button className="btn btn-primary" style={{width: '100%'}} disabled>
              Conciliar
            </button>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-header">
            <h2>📋 Plan de Cuentas</h2>
          </div>
          <div className="card-content">
            <p style={{color: '#666', textAlign: 'center', padding: '2rem'}}>
              Catálogo de cuentas contables
            </p>
            <button className="btn btn-primary" style={{width: '100%'}} disabled>
              Ver Plan
            </button>
          </div>
        </div>
      </div>

      <div style={{
        marginTop: '2rem',
        padding: '1.5rem',
        background: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px',
        textAlign: 'center'
      }}>
        <p style={{margin: 0, color: '#856404'}}>
          ℹ️ Algunos módulos están en desarrollo - Próximamente disponibles
        </p>
      </div>
    </div>
  );
};

export default Contabilidad;
